import materialIconsFont from "@react-native-vector-icons/material-design-icons/fonts/MaterialDesignIcons.ttf";
import React, { useEffect } from "react";
import { View } from "react-native";
import AppFooter from "shared/components/AppFooter.component";
import MainNavigation from "webComponents/AuthNavigation.component";
import ConfirmationModal from "webComponentsFormElements/ConfirmationModal.component";
import ToastContainer from "webComponentsFormElements/ToastContainer.component";
import { AlertProvider } from "webContext/Alert.context";
import { AuthProvider } from "webContext/Auth.context";
import { ConfirmationProvider } from "webContext/Confirmation.context";
import { OrganizationProvider } from "webContext/Organization.context";
import { ToastProvider } from "webContext/Toast.context";

export default function App() {
  useEffect(() => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.textContent = `
      @font-face {
        font-family: "MaterialDesignIcons";
        font-style: normal;
        font-weight: 400;
        src: url(${materialIconsFont}) format("truetype");
      }

      #app-root {
        display: flex;
        flex-direction: column;
        height: 100vh;
      }
    `;
    document.head.appendChild(style);
  }, []);

  return (
    <View style={{ flex: 1, flexDirection: "column" }}>
      <ToastProvider>
        <AuthProvider>
          <ConfirmationProvider>
            <OrganizationProvider>
              <AlertProvider>
                <View style={{ flex: 1 }}>
                  <ConfirmationModal />
                  <ToastContainer />
                  <MainNavigation />
                </View>
              </AlertProvider>
            </OrganizationProvider>
          </ConfirmationProvider>
        </AuthProvider>
      </ToastProvider>
      <AppFooter />
    </View>
  );
}
